import { ReactNode, createContext, useCallback, useContext, useMemo } from "react";
import SnackBar from "../components/Snackbar/Snackbar";
import { SnackBarTypes } from "../utils/commonInterface";

interface SnackbarProviderProps {
  children: ReactNode;
}

const SnackBarContext = createContext({
  snackbar: (type: SnackBarTypes, message: string) => {},
});

export const SnackBarProvider = ({ children }: SnackbarProviderProps) => {
  const snackbar = useCallback((type: SnackBarTypes, message: string) => {
    if (type && message) {
      SnackBar(type, message);
    }
  }, []);

  // Stable identity: consumers of this context never re-render because of it.
  const snackbarValue = useMemo(
    () => ({
      snackbar,
    }),
    [snackbar]
  );
  return (
    <SnackBarContext.Provider value={snackbarValue}>
      {children}
    </SnackBarContext.Provider>
  );
};

export const useSnackBar = () => {
  return useContext(SnackBarContext);
};
